import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ProductSection from "./components/ProductSection";
import FeaturesSection from "./components/FeaturesSection";
import TechnicalSection from "./components/TechnicalSection";
import LayoutSection from "./components/LayoutSection";
import ComparisonSection from "./components/ComparisonSection";
import CatalogSection from "./components/CatalogSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="font-sans bg-white text-[#2B2B2B]">
      <Navbar />
      <HeroSection />
      <ProductSection />
      <FeaturesSection />
      <TechnicalSection />
      <LayoutSection />
      <ComparisonSection />
      <CatalogSection />
      <Footer />
    </main>
  );
}
